import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { EventBus } from '../../../../../shared/event/bus';
import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'admin-photographer-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class AdminSolvimonEventListComponent extends AbstractListComponent implements OnInit, OnDestroy {

  definitions$ = new BehaviorSubject({});
  private selectedDefinition: any;
  eventTypeOptions = [];
  hasDefinitionsLoaded = false;

  // private definitions

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              eventBus: EventBus,
              changeDetector: ChangeDetectorRef,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route);
  }

  getResourceUrl(): string {
    return '/admin/solvimon-event';
  }

  ngOnInit() {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Solvimon',
      url: '/solvimon-events',
    });
    this.parameters.limit = 999;
    this.parameters.offset = 0;
    this.parameters.orderBy = 'id';
    this.parameters.orderDir = 'desc';

    super.ngOnInit();
  }

  load(): Subscription {
    this.loading = true;
    this.loadingPromise = this.fetchRemoteSource().subscribe(() => {
        this.httpClient.get('/admin/solvimon-event/definitions')
          .subscribe((response: { [key: string]: any }) => {

            for (const [event, definition] of Object.entries(response)) {
              this.eventTypeOptions.push({
                label: definition.description,
                value: event,
              });
            }

            this.eventTypeOptions = this.eventTypeOptions.filter((option) => {
              const found = this.pagination.rows.find((event) => event.definition === option.value);
              return !found;
            });

            this.hasDefinitionsLoaded = true;
            this.definitions$.next(response);
          });
      }
    );
    this.loadingPromise.add(() => {
      if (this.pagination.count <= (this.parameters.limit || 10) && this.parameters.offset > 1) {
        this.parameters.offset = 1;
      }
      this.loading = false;
    });
    return this.loadingPromise;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onDelete(rowId) {
    if (!rowId) {
      this.load();
    } else {
      this.delete(rowId);
    }
  }

  add() {
    this.pagination.rows.push({
      __editing: true,
      name: this.eventTypeOptions.find(o => o.value === this.selectedDefinition).label,
      definition: this.selectedDefinition,
    });

    this.eventTypeOptions = this.eventTypeOptions.filter((option) => {
      return option.value !== this.selectedDefinition;
    });

    this.selectedDefinition = null;
  }
}
